import { Component, OnInit, ViewEncapsulation, forwardRef, ElementRef, Renderer, Injector } from '@angular/core';
import { ToggleOption, BaseAbstractControl, mohValidators } from 'moh-package';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, FormGroup, FormControl, ValidatorFn, FormArray } from '@angular/forms';

@Component({
  selector: 'moh-survivors-additional-info',
  templateUrl: './survivors-additional-info.component.html',
  styleUrls: ['./survivors-additional-info.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => SurvivorsAdditionalInfoComponent), multi: true, },
    { provide: NG_VALIDATORS, multi: true, useExisting: forwardRef(() => SurvivorsAdditionalInfoComponent) }]
})
export class SurvivorsAdditionalInfoComponent extends BaseAbstractControl implements OnInit {

  slideToggleOptions: ToggleOption[];
  
  constructor(injector: Injector) {

    super(injector);
  }

  ngOnInit() {

    this.initializeFormGroup();

    this.slideToggleOptions = [new ToggleOption('כן', true), new ToggleOption('לא', false)];

    super.ngOnInit();
  }

  initializeFormGroup() {

    this.baseAbstractControl = new FormGroup({
      DeceasedBirthCountry: new FormControl('', []),
      DeceasedCityInIsrael: new FormControl('', []),
      DeceasedMaidenLastName: new FormControl('', []),
      DeceasedMaidenFirstName: new FormControl('', []),
      DeceasedFatherPrevName: new FormControl('', []),
      DeceasedFatherBirthCountry: new FormControl('', []),
      WasTreatedInTransitCamp: new FormControl(false, []),
      CampName: new FormControl('', []),
      CampCountry: new FormControl('', []),
      TreatedFamilyMembers: new FormArray([new FormControl()]),
      PersonalLetter: new FormControl('', [])
    });
  }

  addFamilyMemberToArray() {

    (<FormArray>this.baseAbstractControl['controls'].TreatedFamilyMembers).push(new FormControl());
  }

  removeFamilyMemberFromArray(index) {

    const control = <FormArray>this.baseAbstractControl['controls'].TreatedFamilyMembers;
    control.removeAt(index);
  }
}



// WEBPACK FOOTER //
// E:/Develop/MOH.Gazezet/Dev/MOH.Gazzezet/MOH.Gazzezet/src/app/components/survivors/survivors-additional-info/survivors-additional-info.component.ts